import { gql } from 'apollo-boost';

export const DELETE_BUSINESS = gql`
  mutation BusinessDelete($id: ID!, $clientMutationId: String) {
    business_delete(input: { businessId: $id, clientMutationId: $clientMutationId }) {
      clientMutationId
    }
  }
`;
